!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.storeblocks=t():e.storeblocks=t()}(self,(()=>(()=>{"use strict";var e={307:(e,t,r)=>{r.d(t,{default:()=>d});var o=r(15),a=r.n(o);const n=require("@storeblocks/button");var l=r.n(n),i=r(279);const d=function(e){var{labelId:t,onClose:r,children:o}=e,n=function(e,t){var r={};for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&t.indexOf(o)<0&&(r[o]=e[o]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var a=0;for(o=Object.getOwnPropertySymbols(e);a<o.length;a++)t.indexOf(o[a])<0&&Object.prototype.propertyIsEnumerable.call(e,o[a])&&(r[o[a]]=e[o[a]])}return r}(e,["labelId","onClose","children"]);return a().createElement(i.HeadingBase,Object.assign({},n),a().createElement("h3",{id:t},o),a().createElement(l(),{"aria-label":"close|lukk",variant:"icon",iconLeft:"close",onClick:r}))}},286:(e,t,r)=>{r.d(t,{default:()=>d});var o=r(15),a=r.n(o),n=r(663),l=r(279),i=r(307);const d=function({open:e,onClose:t,heading:r,content:d,children:s,footer:c,trigger:g,disableAnimation:p}){const{reference:u,floating:b,context:f}=(0,n.useFloating)({open:e,onOpenChange:t}),{isMounted:m,styles:x}=(0,n.useTransitionStyles)(f,{duration:p?0:100}),y=(0,n.useId)(),v=`${y}-label`,h=`${y}-description`,{getReferenceProps:O,getFloatingProps:k}=(0,n.useInteractions)([(0,n.useClick)(f),(0,n.useRole)(f),(0,n.useDismiss)(f)]),w=(0,o.useMemo)((()=>(0,o.isValidElement)(g)&&(0,o.cloneElement)(g,O(Object.assign({ref:u},g.props)))),[g,u,O]),E=(0,o.useMemo)((()=>s?a().Children.map(s,(e=>(0,o.isValidElement)(e)&&e.type===i.default?(0,o.cloneElement)(e,{labelId:v,onClose:t}):e)):a().createElement(a().Fragment,null,a().createElement(i.default,{labelId:v,onClose:t},r),a().createElement(l.Content,null,d),a().createElement(l.Footer,null,c))),[s,r,c,d,t,v]);return a().createElement(a().Fragment,null,w,a().createElement(n.FloatingPortal,null,m&&a().createElement(l.FloatingOverlay,{lockScroll:!0,style:Object.assign({},x)},a().createElement(n.FloatingFocusManager,{context:f},a().createElement(l.ModalBase,Object.assign({},k({ref:b,className:"dialog","aria-labelledby":v,"aria-describedby":h})),E)))))}},279:(e,t,r)=>{r.d(t,{Content:()=>d,FloatingOverlay:()=>c,Footer:()=>s,HeadingBase:()=>i,ModalBase:()=>l});const o=require("styled-components");var a=r.n(o),n=r(663);const l=a().div`
  background: var(--color-background);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  max-width: 672px;
  max-height: calc(100vh - 80px);
  width: 100%;
  z-index: 3;

  @media only screen and (max-width: 672px) {
    max-height: calc(100vh - 32px);
  }

  /* Trick to target only iOS Safari */
  @supports (-webkit-touch-callout: none) {
    max-height: -webkit-fill-available;
  }
`,i=a().div`
  align-items: center;
  border-bottom: 1px solid var(--color-border);
  display: flex;
  justify-content: space-between;
  padding: 32px;

  & > h3 {
    flex: 1;
  }

  & > button {
    color: var(--color-on-background);
  }
`,d=a().div`
  box-sizing: border-box;
  overflow: auto;
  padding: 24px 32px;

  background:
    linear-gradient(white 30%, rgba(255, 255, 255, 0)),
    linear-gradient(rgba(255, 255, 255, 0), white 70%) 0 100%,
    /* Shadows */
      radial-gradient(
        50% 0,
        farthest-side,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0)
      ),
    radial-gradient(
        50% 100%,
        farthest-side,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0)
      )
      0 100%;
  background: /* Shadow covers */
    linear-gradient(white 30%, rgba(255, 255, 255, 0)),
    linear-gradient(rgba(255, 255, 255, 0), white 70%) 0 100%,
    /* Shadows */
      radial-gradient(
        farthest-side at 50% 0,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0)
      ),
    radial-gradient(
        farthest-side at 50% 100%,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0)
      )
      0 100%;
  background-repeat: no-repeat;
  background-color: white;
  background-size:
    100% 40px,
    100% 40px,
    100% 14px,
    100% 14px;
  background-attachment: local, local, scroll, scroll;
`,s=a().div`
  border-top: 1px solid var(--color-border);
  padding: 32px;
`,c=a()(n.FloatingOverlay)`
  background: var(--color-scrim);
  display: grid;
  padding: 16px;
  place-items: center;
  z-index: 2;

  /**
   * Remove padding on small screens to save space.
   */
  @media only screen and (max-width: 374px) {
    padding: 0;
  }

  @media (prefers-reduced-motion) {
    animation: none !important;
    transition: none !important;
  }
`},663:e=>{e.exports=require("@floating-ui/react")},15:e=>{e.exports=require("react")}},t={};function r(o){var a=t[o];if(void 0!==a)return a.exports;var n=t[o]={exports:{}};return e[o](n,n.exports,r),n.exports}r.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return r.d(t,{a:t}),t},r.d=(e,t)=>{for(var o in t)r.o(t,o)&&!r.o(e,o)&&Object.defineProperty(e,o,{enumerable:!0,get:t[o]})},r.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),r.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var o={};return(()=>{r.r(o),r.d(o,{Content:()=>a.Content,Footer:()=>a.Footer,Heading:()=>t.default,default:()=>n});var e=r(286),t=r(307),a=r(279);const n=e.default})(),o})()));
//# sourceMappingURL=index.js.map